<template>
  <section class="section-wrapp">
    <section class="section-graph">
      <div class="container-fluid">
         <div class="buttons-select-field">
           <div class="float-right">
                <flat-pickr
                v-model="dataTime"
                :config="config"
                class="form-control"
                placeholder="Select date"
                name="date" ></flat-pickr>
                <div @click="fetchPower()" class="statistics-select__button">применить <i class="load-style"></i></div>
           </div>
          </div>
        <div class="row">
          <div class="col-12">
            <div class="device-graph-table style device-graph-table-analit">
              <div v-if="haveData && (lastData !== null)" class="device-graph style" style="color:#fff">
                <highcharts :options="chartOptions"></highcharts>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>
<script>
// eslint-disable-next-line standard/object-curly-even-spacing
import { Chart } from 'highcharts-vue'
import StationAPi from '../../api/station'
import StatisticsAPI from '../../api/statistics'
import Object from 'lodash/object'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  name: 'InverterProduction',
  components: {
    'highcharts': Chart,
    flatPickr
  },
  data () {
    return {
      chartOptions: {
        title: {
          text: 'Inverters production',
          style: {
            color: '#ffffff'
          }
        },
        chart: {
          type: 'column',
          backgroundColor: '#3b3c3d',
          zoomType: 'xy'
        },
        legend: {
          enabled: true,
          itemStyle: {
            color: '#ffffff'
          },
          itemHiddenStyle: {
            color: '#595c5e'
          }
        },
        rangeSelector: {
          selected: 1,
          buttons: [{
            type: 'day',
            count: 1,
            text: 'Day'
          },
          {
            type: 'all',
            text: 'All'
          }]
        },
        yAxis: [
          {
            gridLineColor: '#595c5e',
            labels: {
              style: {
                color: '#fff'
              }
            },
            title: {
              style: {
                color: '#fff'
              }
            }
          }
        ],
        xAxis: {
          categories: [],
          labels: {
            style: {
              color: '#fff'
            }
          }
        },
        credits: {
          enabled: false
        },
        series: [
          {
            name: 'Day production, kWH',
            data: [],
            color: '#835fc1',
            borderWidth: 0
          }
        ]
      },
      haveData: false,
      breadcrumbsData: null,
      devices: null,
      lastData: null,
      dateValue: null,
      dataTime: '',
      invertot_properti: {},
      id_invertor: null,
      config: {
        dateFormat: 'Y-m-d H:i',
        mode: 'range'
      }
    }
  },
  methods: {
    async fetchDayPower () {
      let id = this.$route.params.id
      let _this = this
      let array = await StatisticsAPI.fetchDeviceParameters()

      if (this.$store.getters['station/station']) {
        array = StatisticsAPI.fetchDeviceParameters()
      }
      this.$store.dispatch('station/findOne', id)
        .then((station) => {
          _this.breadcrumbsData = [
            {
              url: '/station-view/' + station.id,
              title: station.title
            },
            {
              url: '#',
              title: station.title + ' (Inverters production)'
            }
          ]

          StationAPi.fetchDevices(id)
            .then((r) => {
              _this.devices = r.data
              StationAPi.lastData(id)
                .then((r) => {
                  _this.lastData = r.data
                  console.log(_this.devices)
                  if (_this.devices[ '3' ] !== undefined) {
                    _this.haveData = true
                    let categories = []
                    let data = []
                    let id_invertor = []
                    _this.devices[ '3' ].forEach((device) => {
                      categories.push(device.name)
                      Object.set(this.invertot_properti, device.id, ['Daily AC Energy Injected to grid (kWh)'])
                      id_invertor.push(device.id + '_daily_ac_energy_injected_to_grid_(kwh)')
                      data.push(Object.get(_this.lastData, [
                        device.id,
                        'Daily AC Energy Injected to grid (kWh)'
                      ]))
                    })
                    _this.chartOptions.xAxis.categories = categories
                    _this.chartOptions.series[ 0 ].data = data
                    this.id_invertor = id_invertor
                  }
                })
            })
        })
    },
    fetchPower () {
      let id = this.$route.params.id
      let _this = this
      let formDate = this.dataTime.split(' to ')
      if (formDate.length === 2) {
        let data = []
        _this.$store.dispatch('common/toggleLoading', true)
        StationAPi.fetchData(id, {
          'from': formDate[0] + ':00',
          'to': formDate[1] + ':00',
          'devices': this.invertot_properti
        }).then((r) => {
          _this.haveData = true
          _this.lastData = r.data
          _this.$store.dispatch('common/toggleLoading', false)

          console.log('data', r.data)
          this.id_invertor.forEach((id) => {
            let tim_0 = true
            let ac_power = 0
            if (_this.lastData[id].length !== 0) {
              _this.lastData[id].forEach(
                (power) => {
                  let time = new Date(power[0])
                  if (time.getHours() === 0 && tim_0 === true) {
                    if (power[1] !== 0 && power[1] !== 'null') {
                      ac_power = ac_power + power[1]
                      tim_0 = false
                    }
                  }
                  if (time.getHours() === 1 && tim_0 === false) {
                    tim_0 = true
                  }
                })
              ac_power += _this.lastData[id][_this.lastData[id].length - 1][1]
              data.push(Math.round(ac_power * 100) / 100)
            }
          })
          if (data.length !== 0) {
            _this.chartOptions.series[ 0 ].data = data
          }
        })
      } else {

      }
    }
  },
  created () {
    this.fetchDayPower()
  }
}
</script>
